import React, { useState, useEffect, useRef } from 'react';
import './VideoSplash.css';

const VideoSplash = ({ onComplete }) => {
    const [isVisible, setIsVisible] = useState(true);
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.play().catch(err => {
                console.log('Autoplay prevented:', err);
            });
        }
    }, []);

    const handleVideoEnd = () => {
        setIsVisible(false);
        setTimeout(() => {
            onComplete();
        }, 500);
    };

    const handleSkip = () => {
        setIsVisible(false);
        setTimeout(() => {
            onComplete();
        }, 500);
    };

    if (!isVisible) return null;

    return (
        <div className={`video-splash ${!isVisible ? 'fade-out' : ''}`}>
            <video
                ref={videoRef}
                className="video-splash-player"
                onEnded={handleVideoEnd}
                playsInline
                muted
                autoPlay
            >
                <source src="/vid-start/Main Comp_1.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            
            <button className="video-splash-skip" onClick={handleSkip}>
                Skip →
            </button>
        </div>
    );
};

export default VideoSplash;
